import 'bootstrap-autocomplete';

import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/autocomplete';

export function initialize (context){
    $('[data-autocomplete]:not([data-tags])', context).each(function(){
        let input = $(this),
            data = JSON.parse(input.attr('data-autocomplete')),
            minLength = parseInt(input.get(0).hasAttribute('data-autocomplete-min-length') ? input.attr('data-autocomplete-min-length') : 3),
            noResultsText = input.get(0).hasAttribute('no-results-text') ? input.attr('no-results-text') : 'No results';

        input.autoComplete({
            resolver: 'custom',
            noResultsText: noResultsText,
            minLength: minLength,
            events: {
                search: function (query, callback) {
                    query = query.toLowerCase()
                    let result = [];
                    $(data).each(function(i, el){
                        if (typeof el === typeof '' && el.toLowerCase().search(query) !== -1) {
                            result.push(el);
                        } else if (el.value && el.value.toLowerCase().search(query) !== -1) {
                            result.push({
                                value: el.id,
                                text: el.value
                            });
                        }
                    });
                    callback(result);
                }
            }
        });

        if (!minLength) {
            input.on('focus', function (e) {
                $(this).autoComplete('show');
            });
        }
    });
}

export default {initialize};